import { render } from "./MainSuppliers.vue?vue&type=template&id=a0f43aa0&scoped=true"
import script from "./MainSuppliers.vue?vue&type=script&lang=js"
export * from "./MainSuppliers.vue?vue&type=script&lang=js"

import "./MainSuppliers.vue?vue&type=style&index=0&id=a0f43aa0&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0f43aa0"]])

export default __exports__